module.exports = __webpack_public_path__ + "media/src/images/web/sujet-header-c23b26fe97b40b064ab671e259fb62c6.svg";